import {Option} from 'platform/components';

import {isNil, defaultTo} from 'ramda';

import {GetServiceCaseOrderJobsApiResponse} from '@dms/api/workshop';

import {Nullish} from 'shared/web';

export const getOptionsFromServiceCaseOrderJobs = (
  serviceCaseOrderJobs: GetServiceCaseOrderJobsApiResponse | Nullish
): Option[] => {
  if (isNil(serviceCaseOrderJobs)) {
    return [];
  }
  return serviceCaseOrderJobs.map((serviceCaseOrderJob) => ({
    label: defaultTo('', serviceCaseOrderJob?.name),
    value: defaultTo('', serviceCaseOrderJob?.id),
  }));
};
